@if (metricsData.length) {
    <mat-card class="cardWithShadow">
    <mat-card-content class="p-24">
        <!-- Summary KPIs -->
        <div class="d-flex justify-content-between flex-wrap gap-16">
            @for (key of ['totalCalled', 'totalCompleted', 'totalFailed', 'avgAutomationTime']; track key) {
                <mat-card class="kpi-card">
                    <mat-card-header>
                        <mat-card-title>
                            {{
                                key === 'totalCalled' ? summary.totalCalled :
                                    key === 'totalCompleted' ? summary.totalCompleted :
                                        key === 'totalFailed' ? summary.totalFailed :
                                            key === 'avgAutomationTime' ? summary.avgAutomationTime + ' s' : ''
                            }}
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content class="kpi-label">
                        {{
                            key === 'totalCalled' ? 'Automation Called' :
                                key === 'totalCompleted' ? 'Completed' :
                                    key === 'totalFailed' ? 'Failed' :
                                        key === 'avgAutomationTime' ? 'Avg Automation Time' : ''
                        }}
                    </mat-card-content>
                </mat-card>
            }
        </div>
        <div class="d-flex flex-wrap gap-24" style="margin-top: 24px;">
            <!-- Timeline Chart -->
            <mat-card class="chart-card" style="flex: 1 1 300px;">
                <mat-card-header>
                    <mat-card-title>Avg Workflow Time Over Time</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <apx-chart
                            [chart]="timelineChart"
                            [series]="timelineSeries"
                            [stroke]="timelineStroke"
                            [tooltip]="timelineTooltip"
                            [xaxis]="timelineXAxis">
                    </apx-chart>
                </mat-card-content>
            </mat-card>
            <!-- Issues Donut Chart -->
            <mat-card class="chart-card" style="flex: 1 1 300px;">
                <mat-card-header>
                    <mat-card-title>Workflow Issues</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <apx-chart
                            [chart]="issuesChart"
                            [labels]="issuesLabels"
                            [series]="issuesSeries"
                            [tooltip]="issuesTooltip">
                    </apx-chart>
                </mat-card-content>
            </mat-card>
        </div>
        <!-- Usage Stacked Bar Chart -->
        <mat-card class="chart-card" style="margin-top: 24px;">
            <mat-card-header>
                <mat-card-title>Daily Usage</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <apx-chart
                        [chart]="usageChart"
                        [dataLabels]="usageDataLabels"
                        [legend]="usageLegend"
                        [plotOptions]="usagePlotOptions"
                        [responsive]="usageResponsive"
                        [series]="usageSeries"
                        [xaxis]="usageXAxis">
                </apx-chart>
            </mat-card-content>
        </mat-card>
    </mat-card-content>
    </mat-card>
}
